import {
  AccountDetails,
  SUPPORT_API_LOG_PREFIX,
} from '@twiliointernal/e2-commons-shared-definitions';

import { SupportApi } from '@twiliointernal/e2-commons-shared-api';
import { logger } from '@twiliointernal/e2-commons-shared-libs';
import { FetchUserAccountsOptions } from '../definitions/types';

const fetchUserAccounts = async (
  options?: FetchUserAccountsOptions,
): Promise<AccountDetails[]> => {
  try {
    const userAccountsResponse = await SupportApi.getUserAccounts();

    if (!userAccountsResponse.data) {
      throw new Error('No user accounts found');
    }

    const { accounts } = userAccountsResponse.data;

    return accounts;
  } catch (err) {
    logger.error(`${SUPPORT_API_LOG_PREFIX}::[fetchUserAccounts]::${err}`);
    throw err;
  }
};

export default fetchUserAccounts;
